import { ApiError } from '../api/client.js'
import { UnsupportedGpxSegmentsError } from '@xingroute/schema'
import type { MessageKey } from '../i18n/index.js'

const ERROR_CODE_TO_KEY: Record<string, MessageKey> = {
  conflict: 'error.conflict',
  precondition_failed: 'error.preconditionFailed',
  not_found: 'error.notFound',
  forbidden: 'error.forbidden',
  unauthorized: 'error.unauthorized',
  invalid_request: 'error.invalidRequest',
  invalid_status: 'error.invalidStatus',
  precondition_required: 'error.preconditionRequired',
  slug_taken: 'error.slugTaken',
  payload_too_large: 'error.payloadTooLarge',
  unsupported_media_type: 'error.unsupportedMediaType',
  upstream_error: 'error.upstreamError',
  tianditu_disabled: 'error.tiandituDisabled',
  no_geometry: 'error.noGeometry',
  unsupported_gpx_segments: 'error.unsupportedGpxSegments',
  stale: 'error.stale',
  request_timeout: 'error.requestTimeout',
  invalid_response: 'error.invalidResponse',
  rate_limited: 'error.rateLimited',
  route_not_published: 'error.routeNotPublished',
}

/** Map an error to a user-friendly i18n string. */
export function friendlyError(err: unknown, t: (key: MessageKey) => string): string {
  if (err instanceof UnsupportedGpxSegmentsError) return t('error.unsupportedGpxSegments')
  if (err instanceof ApiError) {
    const key = ERROR_CODE_TO_KEY[err.code]
    if (key) return t(key)
    return err.message
  }
  if (err instanceof TypeError && /fetch|network/i.test(err.message)) {
    return t('error.network' as MessageKey)
  }
  return err instanceof Error ? err.message : String(err)
}
